<template>
  <v-footer dark height="auto">
    <v-card
      flat
      tile
      dark
      class="footer-area grey darken-3 white--text text-xs-center ma-auto"
    >
      <v-card-text>
        <v-btn class="mx-0 white--text" color="white" flat round @click="$utile.move($utile.getBaseUrl() + '/bbs/content.php?co_id=company')">
          회사소개
        </v-btn>
        <v-btn class="mx-0 white--text" color="white" flat round @click="$utile.move($utile.getBaseUrl() + '/bbs/content.php?co_id=privacy')">
          개인정보취급방침
        </v-btn>
        <v-btn class="mx-0 white--text" color="white" flat round @click="$utile.move($utile.getBaseUrl() + '/bbs/content.php?co_id=provision')">
          서비스이용약관
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        <div class="mb-1"><b class="mr-2">고객센터 <a :href="'tel:' + config.company.customerNumber">{{config.company.customerNumber}}</a></b> {{config.company.customerTime}}</div>
        {{config.company.name}} 대표자: {{config.company.owner}} 사업자등록번호: {{config.company.bn}}{{(config.company.ibn) ? ' 통신판매업신고번호:' + config.company.ibn : ''}} 주소: {{config.company.addr}} 이메일: {{config.company.email}}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        &copy;2019 — <strong>{{config.site.domain}}</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
import Utile from '@/utile/utile'
import { mapState } from 'vuex'
//
export default {
  name: 'Footer',
  components: {
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      config: state => state.config
    })
  },
  methods: {
    getBaseUrl () {
      return Utile.getBaseUrl()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue